import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import PackageItinerary from "./PackageItinerary";
import AIGeneratorForm from "./AIGeneratorForm";
import PackageShare from "./PackageShare";
import "./PackageNew.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons';
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

import AIPackageItinerary from "./PackageItinerary";
import PackageTabs from "../AllTabs/PackageTabs";

const AIPackageComponent = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { packageId } = useParams();
  
  const [isGenerating, setIsGenerating] = useState(false);
  const [aiResponseData, setAiResponseData] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);

  // This state will hold the final, customized itinerary data from Step 2
  const [finalItinerary, setFinalItinerary] = useState(null);

  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  const handleGenerateItinerary = async (payloadFromAIForm) => {
    console.log("Sending payload to backend:", payloadFromAIForm);
    setIsGenerating(true);
    setAiResponseData(null); // Clear previous results

    try {
      // 1. MAKE THE ACTUAL API CALL to your backend
      const response = await apiService.post(config.CREATEAIWEBPACKAGE, payloadFromAIForm);

      console.log("Received response from backend:", response);

      // 2. SET THE RESPONSE DATA to state
      if (response) {
        setAiResponseData(response); // Use the live data from the API
        setCompletedSteps([1]);
        setCurrentStep(2);
      } else {
        // Handle cases where the API might return an empty response
        alert("The AI could not generate an itinerary. Please try different options.");
      }
    } catch (error) {
      // 3. HANDLE ERRORS gracefully
      console.error("Error generating itinerary:", error);
      alert(`An error occurred while generating the itinerary: ${error.message || 'Please try again.'}`);
    } finally {
      // 4. STOP THE LOADING INDICATOR
      setIsGenerating(false);
    }
  };

  const handleStepCompletion = (step, customizedData) => {
    if (step === 2) {
      setFinalItinerary(customizedData); // Save the customized data
    }
    setCompletedSteps([...completedSteps, step]);
    setCurrentStep(step + 1);
  };

  const navigateToStep = (step) => {
    if (completedSteps.includes(step - 1) || step === 1) {
      setCurrentStep(step);
    }
  };
  
  if (loading) return <p>Loading...</p>;
  
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <PackageTabs pageName="AIPACKAGE BUILDER" />
              </div>

              <div className="ai-package-builder-wrapper">
                <div className="progress-steps">
                  {[1, 2, 3].map(step => (
                    <div 
                      key={step} 
                      className={`step ${currentStep === step ? 'active' : ''} ${completedSteps.includes(step) ? 'completed' : ''}`}
                      onClick={() => navigateToStep(step)}
                    >
                      <div className="step-icon">
                        {completedSteps.includes(step) ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faCircle} />}
                      </div>
                      <div className="step-label">
                        {step === 1 && "Build Itinerary"}
                        {step === 2 && "Review & Customize"}
                        {step === 3 && "Share Template"}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="step-content">
                  {currentStep === 1 && (
                    <AIGeneratorForm 
                      onGenerate={handleGenerateItinerary} 
                      isGenerating={isGenerating} 
                    />
                  )}

                  {currentStep === 2 && aiResponseData && (
                    <div className="step-panel">
                      <div className="step-header">
                        <h3>Step 2: Review & Customize Your Plan</h3>
                      </div>
                      {/***************************************************/}
                      {/* FIX: Pass the entire aiResponseData object      */}
                      {/***************************************************/}
                      <AIPackageItinerary 
                        packageId={packageId} 
                        initialData={aiResponseData} 
                        onContinueClick={handleStepCompletion}
                      />
                    </div>
                  )}


                  {currentStep === 3 && (
                    <div className="step-panel">
                      <div className="step-header">
                        <h3>Step 3: Share Template</h3>
                      </div>
                      <PackageShare 
                        packageId={packageId} 
                        itineraryData={finalItinerary} // Pass the final customized data
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPackageComponent;